/**
 * Checks to see if a given value is `null` or `undefined`
 *
 * @example
 * import isNil from '@carvana/futilities/isNil';
 * isNil(null)
 * // () => true
 * isNil()
 * // () => true
 * isNil('undefined')
 * // () => false
 * isNil(999)
 * // () => false
 */
function isNil(val: any) {
  return val == null;
}

export default isNil;
